// extracted by mini-css-extract-plugin
export var container = "NoItemsCTA_container__cNDYB";
export var cta = "NoItemsCTA_cta__NjLwf";
export var icon = "NoItemsCTA_icon__b075S fal fa-shopping-bag";
export var mobile = "NoItemsCTA_mobile__J1Os1";
export var title = "NoItemsCTA_title__3Ypob";